export default {
    blocks:         { method: 'get',    url: 'blocks' },
    blocksFilter:   { method: 'get',    url: 'blocks/filter' },
    createBlock:    { method: 'post',   url: 'blocks'},
    updateBlock:    { method: 'put',    url: 'blocks/{id}'},
    deleteBlock:    { method: 'delete', url: 'blocks/{id}'}
}